import PropTypes from 'prop-types';
import { action, extendObservable } from 'mobx';
import moment from 'moment';
import FuseSelectStore from './FuseSelectStore';
import AsyncActionStore from './AsyncActionStore';
import debug from '../debug';
import BoolStore from './helpers/BoolStore';

const FILE_NAME = 'Isolation_Executive_Report';
const REPORT_OPTIONS = [
    { value: 7, label: 'Last 7 Days' },
    { value: 30, label: 'Last 30 Days' },
    { value: 90, label: 'Last 90 Days' }
];
const PERIOD_MAP = {
    7: 'WEEKLY',
    30: 'MONTHLY',
    90: 'QUARTERLY',
};
export default class ReportDownloadStore {
    static PropType = PropTypes.shape({
        isOpen: BoolStore.PropTypes.isRequired,
        datesRangeOptions: FuseSelectStore.PropType.isRequired,
    });

    constructor(data = {}) {
        extendObservable(this, /** @class ReportDownloadStore */{
            reportDownloadStatus: new AsyncActionStore(),
            api: () => Promise.resolve([]),
            isOpen: new BoolStore(false),
            datesRangeOptions: new FuseSelectStore({ options: REPORT_OPTIONS }),
            product: '',
        }, data);
    }

    hideModal = action(() => this.isOpen.setValue(false));

    openModal = action(() => {
        this.resetToDefault();
        this.isOpen.setValue(true);
    });

    resetToDefault = () => this.datesRangeOptions.setSelectedValues([]);

    getValue = () => {
        const selectedOption = this.datesRangeOptions.getFirstValueOrEmpty();
        return {
            product: this.product,
            period: PERIOD_MAP[selectedOption] || '',
        };
    }

    downloadReport = () => {
        if (!this.reportDownloadStatus.isLoading) {
            this.reportDownloadStatus.setLoading(this.api({ ...this.getValue() }))
                .then((pptBlob) => {
                    const url = window.URL.createObjectURL(pptBlob);
                    const link = document.createElement('a');
                    link.href = url;
                    link.download = `${FILE_NAME}_${moment().format('MM_DD_YY')}.pptx`;
                    link.click();
                    this.hideModal();
                }).catch((error) => {
                    debug.warn('downloadReport got error', error);
                });
        }
        return this.reportDownloadStatus.promise;
    }
}
